import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export const cn = (...inputs) => {
    return twMerge(clsx(inputs));
};
export const tw = (strings, ...expressions) => twMerge(strings.reduce((result, currentString, i) => [result, currentString, expressions[i] ?? ""].join(""), ""));
